import { t } from '@services/i18n';

/** Temporary placeholder for member screens not yet ported. */
export function ScreenPlaceholder({ title }: { title: string }) {
  return (
    <div className="rw-page">
      <header className="rw-page-h">
        <div>
          <div className="rw-eyebrow">{t('COM_REWARDIFY_MEMBER', 'Member')}</div>
          <h1 className="rw-h1">{title}</h1>
          <p className="rw-lede">{t('COM_REWARDIFY_PLACEHOLDER_MEMBER_LEDE', 'This member screen is being ported from the design.')}</p>
        </div>
      </header>
      <section className="rw-card">
        <p className="rw-fg1" style={{ fontSize: 13 }}>
          {t('COM_REWARDIFY_PLACEHOLDER_BODY', 'Placeholder for the %s screen.', title)}
        </p>
      </section>
    </div>
  );
}
